<template>
  <div class="child-container">
    <div>
      <div v-if="loading" class="d-flex justify-content-center">
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div v-if="!loading">
        <div v-if="AllCircleMembers.length === 0">
          <div class="dailogbox">
            <div class="dailog-wrapper">
              <span class="dailog">No one added yet</span>
              <span class="sub-dailog">You have not added anyone to your circle yet.</span>
              <a-button
                :style="{ background: getSecondaryColor(), 'pointer-events': 'all', 'font-size': '14px', 'border-radius': '6px', padding: '12px 24px' }"
                class="font-white primary-button profile-btn"
                @click="() => $router.push({ name: 'MeetOthers' })"
              >
                Search and Add
              </a-button>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-for="member in AllCircleMembers" :key="member.id">
            <div v-if="member.role === 'patient' || member.role === 'advocate' || member.role === 'caregiver'" :style="{ 'margin-bottom': '16px' }">
              <div class="claim-card">
                <div class="user-name d-flex p-3">
                  <a @click="viewProfile(member)" class="bg-img d-block background-image">
                    <a-avatar :style="{ color: ' #ffffff !important', 'background-color': (member.url ? member.url : '') ? '' : '#C997C5' }" :size="70" :src="member.url" class="text-capitalize">
                      {{ member.display_name[0] }}
                    </a-avatar>
                  </a>
                  <div class="divider" />
                  <div class="right-items profile-btn">
                    <div class="d-inline-block text-left align-self-center overflow-hidden extra">
                      <p
                        class="bold-text cp mob-name text-capitalize fw700 font20"
                        :style="{ color: '#0F1734', 'line-height': '30px', 'margin-bottom': '8px !important' }"
                        @click="viewProfile(member)"
                      >
                        {{ member.display_name }}
                      </p>
                      <p
                        :style="{ color: '#94A3B8', 'font-weight': '700', 'font-size': '14px', 'line-height': '21px', 'margin-bottom': '8px !important' }"
                        v-if="member.location && member.location[0].city && member.location[0].state"
                        class="m-0 doc-loc text-truncate"
                      >
                        <img src="../../../../assets/images/addphy-location.png" />
                        {{ member.location[0].city }},
                        {{ member.location[0].state }}
                      </p>
                      <p :style="{ color: '#0F1734', 'font-size': '14px', 'line-height': '21px', 'font-weight': 'bold', 'margin-bottom': '8px !important' }">
                        {{ member.no_of_members }} circle members
                      </p>
                    </div>
                    <div class="meet-others">
                      <a-button
                        :style="{ background: getPrimaryColor(), 'pointer-events': 'all', 'font-size': '14px', 'border-radius': '6px', padding: '12px 24px' }"
                        class="font-white primary-button profile-btn"
                        :loading="activeUser === member.id ? isPageRouting : false"
                        @click="viewProfile(member)"
                      >
                        View Profile
                      </a-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <SelfProviderCard
              v-else
              :info="member"
              :type="member.role ? member.role : 'role'"
              :isSelf="true"
              :fetchCircleProviders="fetchCircleProviders"
              @addVirtualDocToCircle="addVirtualDocToCircle($event, addType)"
            />
          </div>
          <div v-if="Bottomloading" class="d-flex justify-content-center">
            <div class="spinner-border position-absolute spinner-class"></div>
          </div>
          <span
            v-if="AllCircleMembers.length != totalCount && !Bottomloading"
            class="viewmore"
            :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block', cursor: 'pointer' }"
            @click="init(true)"
          >
            View More
          </span>
        </div>
      </div>
    </div>
    <RecommendDoctorModal ref="recommendDoctorModal" />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { eventBus } from "../../../../main"
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import SelfProviderCard from "../../../home/provider/selfProfiderCard"
import RecommendDoctorModal from "../../../Modals/RecommendDoctor"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "SelfCircleMembersAll",
  components: {
    SelfProviderCard,
    RecommendDoctorModal,
  },
  data() {
    return {
      Bottomloading: false,
      loading: true,
      isPageRouting: false,
      activeUser: 0,
      virtualDoctors: [],
      currentPage: 1,
      limit: 6,
      showNo: false,
      name: "",
      filterRole: "",
      circleMembers: [],
      AllCircleMembers: [],
      totalCount: 0,
    }
  },

  mounted() {
    console.warn("SelfCircleMembersAll.vue is mounted")
    this.init()
  },

  methods: {
    // get all circle members
    init(append = false) {
      if (append) {
        this.Bottomloading = true
      } else {
        this.loading = true
      }
      UserRepository.getAllCircleMembers(this.authUser.user, this.currentCircle.id, this.currentPage, this.limit)
        .then(res => {
          if (append) {
            this.AllCircleMembers = this.AllCircleMembers.concat(res.data.results)
            this.Bottomloading = false
          } else {
            this.AllCircleMembers = res.data.results ? res.data.results : []
            this.loading = false
          }
          this.totalCount = res.data.total_results ? res.data.total_results : 0
          this.currentPage = this.currentPage + 1
        })
        .catch(err => {
          this.loading = false
        })
    },

    /**
     * View other user profile
     */
    viewProfile(user) {
      this.activeUser = user.id
      this.isPageRouting = true
      if (user.id === this.authUser.user.id) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        UserRepository.getOtherUserProfile(user, this.currentCircle.id)
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
            }
            this.$store.commit("User/setViewUser", { data })
            switch (user.role) {
              case "doctor":
                this.$router.push({
                  name: "ViewDoctorUpdates",
                  params: { id: user.id },
                })
                break
              case "patient":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id },
                })
                break
              case "caregiver":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id, role: 'caregiver' },
                })
                break
              case "advocate":
                this.$router.push({
                  name: "ViewAdvocateUpdates",
                  params: { id: user.id },
                })
                break
              default:
                break
            }
          })
          .catch(err => {})
      }
      // localStorage.setItem('__ou', JSON.stringify(data))
    },

    goToMeetOthers() {
      this.$router.push({
        name: "MeetOthers",
      })
    },

    handleSelectCircle(role) {
      this.filterRole = role
      this.fetchOtherCircleMembers()
    },
  },
}
</script>

<style lang="scss" scoped>
.child-container {
  width: 790px;
  // height: 2716px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.meet-all {
  width: 100%;
  max-width: 400px;
  margin: auto;
  display: flex;
  justify-content: center;
  button {
    width: 50% !important;
    margin: 0;
  }
}
.filter-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.searchContainer {
  background-color: #f1f5f9 !important;
  border-radius: 8px !important;
  border: none !important;

  input {
    border: none !important;
  }
}

.card-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 56px;
}
.search-field {
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  margin-right: 24px;
  height: 60px;
}
.search-button {
  width: 51px;
  background: #f1f5f9;
  border: none;
}
.sort-text {
  font-weight: 400;
  font-size: 14px;
  color: #0f1734;
  margin-bottom: 0px;
  cursor: context-menu;
}

.sub-dailog {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #33415f;
}

.dailog {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}
.dovemed-card {
  .meet-all {
    .dovemed-button-left {
      font-weight: bold;
      border-top-left-radius: 15 !important;
      border-bottom-left-radius: 15 !important;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
    .dovemed-button-right {
      font-weight: bold;
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
      border-top-right-radius: 15 !important;
      border-bottom-right-radius: 15 !important;
    }
  }
}
.search-container {
  display: flex;
  margin-top: 24px;
  gap: 24px;

  .search-input-state {
    background: none;
    border-left: 0 !important;
    height: 60px;
    outline: none;
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;

    &:focus {
      outline: none;
    }
  }

  .search-button {
    max-width: 60px;
    min-width: 60px;
    border-radius: 8px;
    height: 60px;
    &:focus {
      outline: none;
    }
  }
}

.dovemed-button {
  padding: 12px 45px;
}

// STYLES MEETPEOPLE
.meet-others {
  display: flex;
  align-items: center;
  @media screen and (max-width: 600px) {
    display: block;
    margin-top: 20px;
  }
  button {
    display: flex;
    margin-right: 24px;
    font-size: 14px;
    border-radius: 6px;
    padding: 12px 24px;
    width: 126px;
    height: 48px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    @media screen and (max-width: 600px) {
      width: 100%;
      justify-content: center;
    }
  }
  span {
    font-size: 14px !important;
  }
}
.results {
  font-size: 20px;
  color: #0f1734;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
}
.search-field {
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  margin-right: 24px;
}
.signup-page {
  padding: 70px;
}
.divider {
  height: 159px;
  border: 1px solid #cbd5e1;
  margin-top: -16px;
  background: #cbd5e1;
  margin-left: 26.5px;
  @media screen and (max-width: 700px) {
    height: inherit;
    margin-left: 16px;
  }
}

@media screen and (max-width: 750px) {
  .right-items {
    p {
      margin-bottom: 1rem !important;
      margin-top: 0px !important;
    }
  }
}

.mob-name {
  @media screen and (max-width: 750px) {
    display: flex;
    width: 174px;
    flex-wrap: wrap;
  }
}

.search-container {
  display: flex;

  .search-input {
    padding: 10px;
    border-radius: 8px 0 0 8px;
    width: 95%;

    &:focus {
      outline: none;
    }
  }
  display: flex;
  align-items: center;
  .search-input-state {
    border-left: 0 !important;
    padding: 10px;
    width: 320px;

    &:focus {
      outline: none;
    }
  }
  .dropdownOptions {
    margin-right: 154px;
  }

  .search-button {
    max-width: 100px;
    padding: 11px;

    @media screen and (max-width: 900px) {
      padding: 6px;
    }

    &:focus {
      outline: none;
    }
  }
}

.input-placeholder {
  min-width: unset;

  &.male {
    border-radius: 20px 0 0 20px;
  }

  &.female {
    border-radius: 0 0 0 0;
    margin-left: -5px;
  }
  &.other {
    border-radius: 0 20px 20px 0;
    margin-left: -5px;
  }
}

.claim-card {
  border: 1px solid #e2e8f0;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  .user-name {
    height: 159px;
    @media screen and (max-width: 700px) {
      height: 213px;
    }

    .bg-img {
      position: relative;
      // border: 1px solid #ccc;
      // min-width: 100px;
      max-width: 100px;
      min-height: 100px;
      max-height: 100px;
      border-radius: 50%;
      display: inline-block;
      margin-top: 24px;
      margin-left: 19.5px;
      @media screen and (max-width: 700px) {
        margin-left: 0px;
        margin-top: 0px;
      }
      .rating-badge {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 20%);
        font-size: 15px;
        border-radius: 20px;
        width: 55%;
      }
    }
  }

  .user-address {
    line-height: 15px;
  }

  .dovemed-card-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.125);

    span {
      font-size: 12px;
    }
  }
}

.claim-modal-header {
  border-radius: 5px 5px 0 0;
  min-height: 100px;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;

  .profile-img {
    min-width: 150px;
    max-width: 150px;
    min-height: 150px;
    max-height: 150px;
    display: block;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.4);
  }
}

.profile-details {
  padding-top: 170px;
  max-width: 60%;
  margin: auto;
}

.terms-modal-container {
  padding: 30px;
  text-align: center;
}

.background-image {
  background-position: center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}

.filters-cont {
  transition: height 0.3s ease-in-out;
}

.transparent {
  opacity: 0;
  display: none;
}

.no-results-container {
  background: rgb(246, 246, 246);
  padding: 20px;
  border-radius: 8px;
}
@media screen and (max-width: 581px) {
  .search-input-state {
    width: 100%;
  }
  .filters-cont {
    .filter-content {
      display: flex;
      flex-direction: column;
    }
    .input-placeholder {
      padding: 8px 8px;
    }
  }
}
.clear-filter {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  text-decoration-line: underline;
  margin-top: 24px;
  margin-right: 28px;
}
.right-items {
  display: flex;
  width: 100%;
  justify-content: space-between;
  overflow: none !important;
  margin-left: 24px;
  span {
    font-size: 14px !important;
  }

  @media screen and (max-width: 900px) {
    display: block;
    margin-left: 15.5px;
    width: 100%;
  }

  @media screen and (max-width: 600px) {
    display: block;
    margin-left: 15.5px;
  }
}

.no-data-block {
  font-size: 14px;
  line-height: 24px;
  &__bold {
    font-weight: bold;
  }
  &--bottom {
    display: flex;
    justify-content: space-around;
    padding-top: 15px;
    flex-wrap: wrap;
    &__list {
      @media screen and (max-width: 900px) {
        margin: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/profile/circle/SelfCircleMembersAll.vue